<template>
  <div class="bravado-infinite-scroll-loader">
    <component
      :is="dot.component"
      v-for="dot in dots"
      :key="dot.key"
      v-bind="dot.attrs"
      class="bravado-infinite-scroll-loader__dot"
    >
      <div v-if="dot.component === 'a' && withLinks === true" />
      <span v-if="dot.page" class="bravado-infinite-scroll-loader__text">Page {{ dot.page }}</span>
    </component>
  </div>
</template>

<script lang="ts">
import type { PropOptions } from 'vue';
import Vue from 'vue';

interface IDot {
  component: string;
  key: number;
  attrs?: Record<string, string>;
  page?: string;
}

const DEFAULT_LOADING_DOT_COUNT = 5;

export default Vue.extend({
  name: 'BravadoInfiniteScrollLoader',
  props: {
    links: {
      type: Array,
      default: () => [],
    } as PropOptions<Array<string>>,
    dotCount: {
      type: Number,
      default: DEFAULT_LOADING_DOT_COUNT,
    } as PropOptions<number>,
    withLinks: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    dots(): Array<IDot> {
      return [...Array(this.dotCount).keys()].map((el, index) => {
        const key = el;
        if (!this.links[index] || this.withLinks === false) {
          return {
            component: 'div',
            key,
          };
        }
        const page = this.links[index].match(/\d*$/g)?.[0];

        return {
          component: 'a',
          key,
          attrs: { href: this.links[index] },
          page,
        };
      });
    },
  },
});
</script>

<style scoped lang="scss">
.bravado-infinite-scroll-loader {
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 0;

  &__text {
    width: 0;
    height: 0;
    overflow: hidden;
    opacity: 0;
    text-indent: -1000px;
  }

  &__dot {
    width: 8px;
    height: 8px;
    background: var(--gray-50);
    border-radius: 50%;
    animation-name: blink;
    animation-duration: 1.4s;
    animation-iteration-count: infinite;
    animation-fill-mode: both;

    &:nth-child(2) {
      animation-delay: 0.2s;
    }

    &:nth-child(3) {
      animation-delay: 0.4s;
    }

    &:nth-child(4) {
      animation-delay: 0.6s;
    }

    &:nth-child(5) {
      animation-delay: 0.8s;
    }

    & + & {
      margin-left: 8px;
    }
  }

  @keyframes blink {
    0% {
      opacity: 0.2;
    }

    20% {
      opacity: 1;
    }

    100% {
      opacity: 0.2;
    }
  }
}
</style>
